/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DropdownOption/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import * as fromFlow from 'Simple/Flow'
import CheckSelected from 'DesignSystem/Svgs/CheckSelected/index'
import Info from 'DesignSystem/Info/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function DropdownOption({
  children,
  viewPath = "/DesignSystem/DropdownOption",
  height = 40,
  width = "100%",
  disabled,
  onlyForHoverFixMeInTheMorpherThanks,
  onClick,
  alignSelf,
  isSelected,
  text = "Option",
  textAlign,
  fontSize = 14,
  banner
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<div
  data-testid="DropdownOption.Horizontal"
  data-view-path={viewPath}
 style={{'--h-1-Zajicj': typeof height === 'number' ? `${height}px` : height,'--w-2-Zajicj': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Horizontal}`}
>
<button
  data-testid="DropdownOption.Horizontal:1"
  data-view-path={viewPath}
 disabled={disabled}
 {...isHoveredBind}
 onClick={onlyForHoverFixMeInTheMorpherThanks}
 onMouseDown={onClick}
 style={{'--as-4-Zajicj': alignSelf,'--bc-3-Zajicj': isSelected ? "rgba(0,207,104, 0.1)" : isHovered ? "rgba(0,207,104, 0.15)" : "#ffffff"}}
 className={`views-block ${styles.Horizontal1}`}
>
<span
  data-testid="DropdownOption.Text"
  data-view-path={viewPath}
 style={{'--ta-5-Zajicj': textAlign,'--fs-6-Zajicj': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--c-7-Zajicj': isSelected ? "rgb(0,188,112)" : "#606060",'--ws-8-Zajicj': isMedia.mobile ? "wrap" : "nowrap"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
<CheckSelected
  viewPath={`${viewPath}/CheckSelected`}
 opacity={isSelected ? 1 : 0}
/>
<fromFlow.When is={banner}>
<div
  data-testid="DropdownOption.Vertical"
  data-view-path={viewPath}
 style={{'--tx-9-Zajicj': isHovered ? "230px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text={banner}
 fontSize={12}
 color="rgba(255,127,0,1)"
 marginTop={1}
 fontWeight={600}
/>
</div>
</fromFlow.When>
</button>
</div>
{children}
</React.Fragment>)
}